import { commonLang } from '@umu/ukit-lang';
/**
 * @description loadmore
 * @author duanjun
 * @date
 */

import Button from '../form/@button/button';
import React, { Component } from 'react';
import './loadMore.scss';

interface ILoadMoreProps {
    totalPageNum: number;
    currentPage: number;
    load(): void;
}

export default class LoadMore extends Component<ILoadMoreProps, {}> {
    constructor(props: ILoadMoreProps) {
        super(props);
        this.load = this.load.bind(this);
    }

    public load() {
        this.props.load();
    }

    public render() {
        return (
            <div
                className="load-more"
                style={{ display: this.props.totalPageNum > this.props.currentPage ? '' : 'none' }}
            >
                <Button onClick={this.load} className="do-load" alias="text" type="optional">
                    {commonLang('查看更多')}
                    <i className="icon icon-arrow arrow1 size-s gray down"></i>
                </Button>
            </div>
        );
    }
}
